/* eslint-disable */
import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
//css
import 'contents/assets/scss/page/accounting.scss';
//component
import Tab from '../../../component/Inc/Tab';
import Calendar from '../../../component/Inc/Calendar';
import Modal from '../../../component/Inc/Modal';

function AccountingCalculate() {
  const navigate = useNavigate();
  const [tabIdx, setTabIdx] = useState(0);
  const [modalAlert, setModalAlert] = useState(0);

  const tab01 = [
    {title: '정산 대기', value: 0},
    {title: '정산', value: 1},
    {title: '지급 완료', type: 'blue', value: 2}
  ];
  return (
    <main className="com_container ">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu8_5 active">교사 수업 정산 관리</h2>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
                <Tab data={tab01} tab={tabIdx} setTab={setTabIdx} tabStyle="fit_cont" />
              </div>
              <section className="com_board_search end">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <hr className="com_divider" />
            <Calendar />
            <div className="com_board_list__top">
              <div className="board_select">
                <div className="check">
                  <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                  <label htmlFor="rdo01">전체</label>
                  <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                  <label htmlFor="rdo02">교사</label>
                  <input type="radio" name="rdo" id="rdo03" className="com_chk circle" />
                  <label htmlFor="rdo03">수시교사</label>
                </div>
              </div>
              <section className="com_board_search end">
                <div className="com_count_wrapper">
                  <div className="operators">
                    <div className="operators_label">
                      <span className="operators_count">총 입금 건수</span>
                      <span className="operators_value">98건</span>
                    </div>
                  </div>
                  <div className="turnover">
                    <div className="turnover_label">
                      <span className="turnover_count">총 입금액</span>
                      <span className="turnover_value">46,500,000</span>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4.5%" />
                <col width="8.2%" />
                <col width="8.2%" />
                <col width="8.2%" />
                <col width="8.2%" />
                <col width="9.5%" />
                <col width="9.5%" />
                <col width="8.2%" />
                <col width="8.2%" />
                <col width="8.2%" />
                <col />
                <col width="5.1%" />
              </colgroup>
              <thead>
                <tr>
                  <th>선택</th>
                  <th>교사명</th>
                  <th>학생 수</th>
                  <th>영역</th>
                  <th>총 회차 / T</th>
                  <th>총 진행 수업 회차</th>
                  <th>익월 진행 수업 회차</th>
                  <th>기본 시수</th>
                  <th>수수료 (30%)</th>
                  <th>총 정산금액</th>
                  <th>정산 상태</th>
                  <th>보기</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                    <label htmlFor="chk010"></label>
                  </td>
                  <td>
                    <button className="btn_link">김교사123</button>
                  </td>
                  <td>8</td>
                  <td>과탐</td>
                  <td>480회 / 2T</td>
                  <td>45회</td>
                  <td>36회</td>
                  <td>500,000</td>
                  <td className="td_red">-45,000</td>
                  <td className="td_point">7,889,000</td>
                  <td className="td_red">
                    <button className="btn_link txt">정산대기</button>
                  </td>
                  <td className="td_point">
                    <button className="btn_link txt" onClick={() => navigate('/Accounting/Calculate/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                    <label htmlFor="chk010"></label>
                  </td>
                  <td>
                    <button className="btn_link">수시교사</button>
                  </td>
                  <td>8</td>
                  <td>과탐</td>
                  <td>480회 / 2T</td>
                  <td>45회</td>
                  <td>36회</td>
                  <td>500,000</td>
                  <td className="td_red">-45,000</td>
                  <td className="td_point">7,889,000</td>
                  <td>
                    <button className="btn_link txt">
                      정산
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="btn_link txt" onClick={() => navigate('/Accounting/Calculate/DetailSub')}>
                      보기
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>
                    <input type="checkbox" name="chk" id="chk010" className="com_chk" />
                    <label htmlFor="chk010"></label>
                  </td>
                  <td>
                    <button className="btn_link">김교사123</button>
                  </td>
                  <td>8</td>
                  <td>과탐</td>
                  <td>480회 / 2T</td>
                  <td>45회</td>
                  <td>36회</td>
                  <td>500,000</td>
                  <td className="td_red">-45,000</td>
                  <td className="td_point">7,889,000</td>
                  <td className="td_point">
                    <button className="btn_link txt">
                      지급완료
                      <br />
                      2023, 05, 12
                    </button>
                  </td>
                  <td className="td_point">
                    <button className="btn_link txt" onClick={() => navigate('/Accounting/Calculate/Detail')}>
                      보기
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_list__bottom">
              <button
                onClick={() => {
                  setModalAlert(true);
                }}
                className="com_btn black xs"
              >
                선택항목 정산
              </button>
              <div className="com_btn_wrap">
                <button className="com_btn black xs btn_down_orange">다운로드</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Modal open={modalAlert} close={() => setModalAlert(false)} type="type_alert">
        <div className="content_container">
          <div className="txt padding_bottom_no">선택항목을 정산 하시겠습니까?</div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default AccountingCalculate;
